import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createMemoryHistory } from 'history';

import registerServiceWorker from './registerServiceWorker';
import configureStore from './configureStore';
import processWidgetData from './utils/processWidgetData';

import Widget from './containers/Widget/Widget.jsx';

export const topLevelComponent = data => {
    const history = createMemoryHistory({
        basename: process.env.PUBLIC_URL
    });
    const store = configureStore(
        {
            widget: processWidgetData(data)
        },
        history
    );
    return (
        <Provider store={store}>
            <Widget history={history} />
        </Provider>
    );
};

export default function start(data, page) {
    const history = createMemoryHistory({
        basename: process.env.PUBLIC_URL
    });
    const store = configureStore(
        {
            widget: processWidgetData({
                ...data,
                articleUrl: page.articleUrl,
                embedType: page.embedType
            })
        },
        history
    );

    render(
        <Provider store={store}>
            <Widget history={history} />
        </Provider>,
        document.getElementById(page.widgetContainerId)
    );

    if (module.hot) {
        module.hot.accept('./containers/Widget/Widget.jsx', () => {
            render(
                <Provider store={store}>
                    <Widget history={history} />
                </Provider>,
                document.getElementById(page.widgetContainerId)
            );
        });
    }

    registerServiceWorker();
}
